import { Controller } from "@hotwired/stimulus"

// Inline rename for a GDPR register entry (legacy: the entry name was editable
// straight in the list row). Click the title -> it becomes an input; Enter or
// blur saves via PATCH /customers/shops/:id, Escape reverts. The row never
// reloads.
export default class extends Controller {
  static targets = ["display", "input"]
  static values = { url: String }

  edit() {
    this.original = this.displayTarget.textContent.trim()
    this.inputTarget.value = this.original
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.inputTarget.blur()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.inputTarget.value = this.original
      this.cancel()
    }
  }

  cancel() {
    this.inputTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }

  async save() {
    // Escape already reverted and hid the input; nothing to persist.
    if (this.inputTarget.classList.contains("hidden")) return

    const title = this.inputTarget.value.trim()
    if (title === "" || title === this.original) {
      this.cancel()
      return
    }

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken || ""
        },
        credentials: "same-origin",
        body: JSON.stringify({ shop: { title } })
      })

      if (response.ok) {
        const data = await response.json()
        this.displayTarget.textContent = data.title
      } else {
        this.displayTarget.textContent = this.original
      }
    } catch {
      this.displayTarget.textContent = this.original
    }

    this.cancel()
  }
}
